import dayjs from "dayjs"
const mapScheduleDataToWeekdays = data => {
  const mappedValues = []
  //3 is the id of inOffice roster Status
  for (let i = 1; i <= 7; i++) {
    if (data?.[`wd${i}`] === 3) {
      mappedValues.push(`Weekday${i}`)
    }
  }
  return mappedValues
}

const mapScheduleDataToWeekHours = data => {
  return !!data ? [dayjs(data.startTime, "HH:mm:ss"), dayjs(data.endTime, "HH:mm:ss")] : []
}

const mapAdditionalLanguages = data => {
  const mappedLanguage = []
  data.forEach(element => {
    mappedLanguage.push(element.languageId)
  })
  return mappedLanguage
}

const staffDetailsTransformer = response => {
  return {
    ...response,
    transformedImageArray: response?.picture
      ? [
          {
            url: response?.picture,
            croppedUrl: response?.transformedPicture,
            crop: response?.Attachments?.[0]?.ImageTransformations?.[0]?.configs,
            name: response?.Attachments?.[0]?.name,
            uid: response?.Attachments?.[0]?.ImageTransformations?.[0]?.id,
            s3Key: response?.Attachments?.[0]?.ImageTransformations?.[0]?.sourceS3Key,
            isInvalidAspectRatio: false,
          },
        ]
      : [],
    ...(response?.UserLanguageMappings && {
      additionalLanguages: mapAdditionalLanguages(response.UserLanguageMappings),
    }),
    ...(response?.UserWeeklySchedule && { weekDays: mapScheduleDataToWeekdays(response.UserWeeklySchedule) }),
    ...(response?.UserWeeklySchedule && { weekHours: mapScheduleDataToWeekHours(response?.UserWeeklySchedule) }),
  }
}

export default staffDetailsTransformer
